export type AccessToken = string & { readonly __brand: "AccessToken" };

export type TokenResult =
  | { ok: true; token: AccessToken }
  | { ok: false; reason: "auth" | "network" | "unknown" };

/** How a failed Supabase refresh should be handled. See spec §3.3. */
export enum AuthErrorClass {
  /** refresh token is dead (invalid / expired / already-used) → sign out */
  GENUINE = "genuine",
  /** network / timeout / unknown → surface, retry later, never sign out */
  TRANSIENT = "transient",
}
